module.exports = {"621021100":"庆城镇","621021101":"驿马镇","621021102":"三十里铺镇","621021103":"马岭镇","621021104":"玄马镇","621021105":"白马铺镇","621021106":"桐川镇","621021107":"赤城镇","621021108":"高楼镇","621021203":"太白梁乡","621021204":"土桥乡","621021205":"蔡口集乡","621021207":"南庄乡","621021208":"翟家河乡","621021209":"蔡家庙乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/621021.json
// module id = 3079
// module chunks = 0